import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Input, Form, FormGroup, Label } from "reactstrap";
import { getStorageUser } from "../../../helpers/api_helper";
import { resourcesFiles } from "../../../helpers/backend_helper";

const Columns = (
  addUpd,
  destroy,
  active,
  setModalObserv,
  setModalFile,
  authUser
) => {
  /*
	if (authUser.id != row.administrator_id) {
		let admin_name = {
			id: 'admin_name',
			name: 'Administrador',
			selector: row => row.admin_name,
			sortable: true,
			wrap: true,
			width:'40%'
		}
	}else{

	}
*/
  const getFiles = (id) => {
    let params = {
      params: { relation: "operator", id: id, field: "operator_id" },
    };
    resourcesFiles("get", params).then((response) => {
      setModalFile({ show: true, id: id, items: response.files });
    });
  };

  let columns = [
    {
      id: "key",
      name: "Clave",
      selector: (row) => row.key,
      sortable: true,
      width: "100px",
    },
    {
      id: "full_name",
      name: "Nombre",
      selector: (row) => row.full_name,
      sortable: true,
    },
    {
      id: "unit_number",
      name: "Unidad",
      selector: (row) => row.unit?.number ?? '-',
      sortable: true,
      width: "100px",
    },
    {
      id: "date_out",
      name: "Activo",
      selector: (row) => row.date_out ? <i className="text-secondary fa fa-times"></i> : <i className="text-success fa fa-check"></i>,
      sortable: true,
      width: "100px",
    },
    {
      id: "observations",
      name: "Documentación",
      width: "120px",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Listado de Documentos"
              onClick={() => getFiles(row.id)}
            >
              <i className="fa fa-folder-open"></i>
            </button>
          </div>
        </div>
      ),
    },
    {
      id: "files",
      name: "Observaciones",
      width: "120px",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              onClick={() =>
                setModalObserv({ show: true, type: 1, id: row.id })
              }
              className="btn btn-primary btn-sm"
              title="Observaciones"
            >
              <i className="fa fa-eye"></i>
            </button>
          </div>
        </div>
      ),
    },
    {
      id: "actions",
      name: "Acciones",
      width: "15%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar operador"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="pe-2">
            <button
              className="btn btn-danger btn-sm"
              title="Eliminar operador"
              onClick={() => destroy(row.id)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];

  if (authUser.profile_id == 2) {
    columns = [
      {
        id: "ruta",
        name: "Ruta",
        selector: (row) => row.route.name,
        sortable: true,
        wrap: true,
      },
      ...columns,
    ];
  }

  return columns;
};

export default Columns;
